module.exports = __webpack_public_path__ + "img/instagram.de77d55.svg";